import React from 'react'
import {Component} from 'react'
import { message, Spin } from 'antd'
import '../assets/css/index.scss'
import http from '../api/email'

var all_language = [
    {
      language: 'ar',
      messages:
        {
          pinreset: 'إعادة تعيين دبوس',
          new: 'دبوس جديد',
          c: 'قم بتأكيد رقم التعريف الشخصي الجديد',
          resetpin: 'إعادة تعيين دبوس',
          s: 'اكتملت إعادة التعيين بنجاح!',
          u: 'يمكنك استخدام رقم التعريف الشخصي الجديد لإيقاف وضع الذعر في أي وقت.',
          d: 'الدبابيس لا تتطابق',
          p: 'الرجاء إدخال دبوس مكون من 4 أحرف'
        }
    },
    {
      language: 'de',
      messages:
        {
          pinreset: 'Stift zurücksetzen',
          new: 'neuer Pin',
          c: 'Neue PIN bestätigen',
          resetpin: 'PIN zurücksetzen',
          s: 'Zurücksetzen erfolgreich!',
          u: 'Mit der neuen PIN können Sie den Panikmodus jederzeit verlassen.',
          d: 'Die beiden Pins stimmen nicht überein',
          p: 'Bitte geben Sie eine PIN mit 4 Zeichen ein'
        }
    },
    {
      language: 'fr',
      messages:
        {
          pinreset: 'Broche Réinitialiser',
          new: 'Nouvelle épingle',
          c: 'Confirmer le nouveau NIP',
          resetpin: 'Broche de réinitialisation',
          s: 'Réinitialisation réussie !',
          u: 'Vous pouvez utiliser le nouveau code PIN pour mettre fin au mode panique à tout moment.',
          d: 'Les deux broches ne correspondent pas',
          p: 'Veuillez saisir un code PIN à 4 caractères'
        }
    },
    {
        language: 'fr-FR',
        messages:
          {
            pinreset: 'Broche Réinitialiser',
            new: 'Nouvelle épingle',
            c: 'Confirmer le nouveau NIP',
            resetpin: 'Broche de réinitialisation',
            s: 'Réinitialisation réussie !',
            u: 'Vous pouvez utiliser le nouveau code PIN pour mettre fin au mode panique à tout moment.',
            d: 'Les deux broches ne correspondent pas',
            p: 'Veuillez saisir un code PIN à 4 caractères'
          }
      },

      {
        language: 'fr-fr',
        messages:
          {
            pinreset: 'Broche Réinitialiser',
            new: 'Nouvelle épingle',
            c: 'Confirmer le nouveau NIP',
            resetpin: 'Broche de réinitialisation',
            s: 'Réinitialisation réussie !',
            u: 'Vous pouvez utiliser le nouveau code PIN pour mettre fin au mode panique à tout moment.',
            d: 'Les deux broches ne correspondent pas',
            p: 'Veuillez saisir un code PIN à 4 caractères'
          }
      },
  
    {
      language: 'ru',
      messages:
        {
          pinreset: 'Сбросить PIN-код',
          new: 'Новый пин',
          c: 'Подтвердите новый PIN-код',
          resetpin: 'Сбросить PIN-код',
          s: 'Сброс выполнен успешно!',
          u: 'Вы можете использовать новый PIN-код для выхода из режима паники в любое время.',
          d: 'Два контакта не совпадают',
          p: 'Пожалуйста, введите 4-значный PIN-код'
        }
    },
    {
      language: 'it',
      messages:
        {
          pinreset: 'Ripristino pin',
          new: 'Nuovo numero pin',
          c: 'Conferma nuovo pin',
          resetpin: 'Reimposta pin',
          s: 'Il ripristino ha funzionato',
          u: 'Puoi utilizzare il nuovo PIN per interrompere la modalità panico in qualsiasi momento.',
          d: 'I due pin non corrispondono',
          p: 'Inserisci un pin a 4 numeri'
        }
    },
    {
        language: 'it-it',
        messages:
          {
            pinreset: 'Ripristino pin',
            new: 'Nuovo numero pin',
            c: 'Conferma nuovo pin',
            resetpin: 'Reimposta pin',
            s: 'Il ripristino ha funzionato',
            u: 'Puoi utilizzare il nuovo PIN per interrompere la modalità panico in qualsiasi momento.',
            d: 'I due pin non corrispondono',
            p: 'Inserisci un pin a 4 numeri'
          }
      },

      {
        language: 'it-IT',
        messages:
          {
            pinreset: 'Ripristino pin',
            new: 'Nuovo numero pin',
            c: 'Conferma nuovo pin',
            resetpin: 'Reimposta pin',
            s: 'Il ripristino ha funzionato',
            u: 'Puoi utilizzare il nuovo PIN per interrompere la modalità panico in qualsiasi momento.',
            d: 'I due pin non corrispondono',
            p: 'Inserisci un pin a 4 numeri'
          }
      },
  
    {
      language: 'hi',
      messages:
        {
          pinreset: 'पिन रीसेट',
          new: 'नया पिन',
          c: 'नए पिन की पुष्टि करें',
          resetpin: 'पिन रीसेट करें',
          s: 'रीसेट सफल!',
          u: 'आप किसी भी समय पैनिक मोड को रोकने के लिए नए पिन का उपयोग कर सकते हैं।',
          d: 'दो पिन मेल नहीं खाते',
          p: 'कृपया 4 नंबर पिन दर्ज करें'
        }
    },
    {
      language: 'ENGLISH',
      messages:
        {
          pinreset: 'Pin Reset',
          new: 'New Pin',
          c: 'Confirm New Pin',
          resetpin: 'Reset Pin',
          s: 'Reset successful!',
          u: 'You can use the new PIN to stop Panic Mode at any time.',
          d: 'The two pin do not match',
          p: 'Please enter a pin of 4 character'
        }
    }
  
  
  
  ]
  
class Pin extends Component{
    constructor() {
        super()
        this.state = {
            psd: '',
            psdWarn: false,
            rpsd: '',
            rpsdWarn: false,
            loading: false,
            timer: null,
            success: false,
            email: null,
            session: null,
            titleInformations: {
                pinreset: '',
                new: '',
                c: '',
                resetpin: ''
            },
            lang: ''
        }
    }

    handleChange = (key, e) => {
        if (key === 'psd') {
            let temp = e.target.value
            temp = temp.replace(/\D+/g, '')
            this.setState({
                psd: temp
            }, () => {
                if (this.state.psd.replace(/\s+/g,'') !== '') {
                    this.setState({
                        psdWarn: false
                    })
                }
            })
        } else if (key === 'rpsd') {
            let temp = e.target.value
            temp = temp.replace(/\D+/g, '')
            this.setState({
                rpsd: e.target.value
            }, () => {
                if (this.state.rpsd.replace(/\s+/g,'') !== '') {
                    this.setState({
                        rpsdWarn: false
                    })
                }
            })
        }
    }

    keyup = (e) => {
        if (e.keyCode === 13) {
            this.sign()
        }
    }

    resetDefault = () => {
        this.setState({
            loading: false
        })
    }

    componentDidMount () {
        /********************************获取系统语言start*******************************/
        let lang = navigator.language || navigator.userLanguage
        if (lang.indexOf('-') !== -1)
            lang = lang.split('-')[0]

        if (lang === 'ar' || lang === 'de' || lang === 'fr' || lang === 'ru' || lang === 'it' || lang === 'hi' || lang === 'fr-FR' || lang === 'fr-fr' || lang === 'it-IT' || lang === 'it-it') {
            let item = all_language.find((i) => {
            return i.language === lang
            })
            this.setState({
            titleInformations: item.messages,
            lang: item.language
            })
        } else {
            let item = all_language.find((i) => {
            return i.language === 'ENGLISH'
            })

            this.setState({
            titleInformations: item.messages,
            lang: item.language
            })
        }
        /********************************获取系统语言end*******************************/
        
        if (this.props.location.search.indexOf('?') !== -1) {
            let first = this.props.location.search.split('?')[1]
            if (first.indexOf('email=') !== -1 && first.indexOf('&sessionId=') !== -1) {
                let second = first.split('&')
                let third = {}
                second.forEach(item => {
                    let temp = item.split('=')
                    third[temp[0]] = temp[1]
                })
                this.setState({
                    email: third.email,
                    session: third.sessionId
                })
            }
        }
        window.scrollTo(0, 0)
    }

    sign = () => {
        if (this.state.psd.replace(/\s+/g,'') === '') {
            this.setState({
                psdWarn: true
            })
        }
        if (this.state.rpsd.replace(/\s+/g,'') === '') {
            this.setState({
                rpsdWarn: true
            })
        }
        if (this.state.psd.replace(/\s+/g,'') === '' || this.state.rpsd.replace(/\s+/g,'') === '') {
            return
        }
        if (this.state.psd.replace(/\s+/g,'') !== this.state.rpsd.replace(/\s+/g,'')) {
            this.setState({
                psdWarn: true,
                rpsdWarn: true
            })
            message.warning(this.state.titleInformations.d)
            return
        }
        if (this.state.psd.replace(/\s+/g,'').length !== 4) {
            message.warning(this.state.titleInformations.p)
            return
        }

        if (this.state.email === null || this.state.session === null) {
            return
        }

        this.setState({
            loading: true,
            timer: setInterval(this.resetDefault, 60000)
        })

        http.renewPin({
            params: {
                pin: this.state.psd,
                email: this.state.email,
                sessionId: this.state.session
            },
            callback: this.callback
        })
    }

    callback = (res) => {
        this.setState({
            loading: false
        })
        clearInterval(this.state.timer)
        if (res.data.code === 0) {
            this.setState({
                success: true
            })
        } else {
            message.warning(res.data.message)
        }
    }

    render() {
        let load = ''
        if (this.state.loading) {
            load = <Spin />
        } else {
            load = ''
        }
        return (
            <div className="dark">
                <div className="cont">
                    <div className="logo"></div>
                    <div className="box">
                        {this.state.success !== true ? <div className="in">
                            <h1>{this.state.titleInformations.pinreset}</h1>
                            <h2>{this.state.titleInformations.new}</h2>
                            <div className={this.state.psdWarn ? 'input-item blue' : 'input-item'}>
                                <input onKeyUp={this.keyup} type="password" value={this.state.psd} onChange={this.handleChange.bind(this, 'psd')} maxLength="4" />
                            </div>
                            <h2>{this.state.titleInformations.c}</h2>
                            <div className={this.state.rpsdWarn ? 'input-item blue' : 'input-item'} style={{'marginBottom':'50px'}}>
                                <input onKeyUp={this.keyup} type="password" value={this.state.rpsd} onChange={this.handleChange.bind(this, 'rpsd')} maxLength="4" />
                            </div>
                            <button onClick={this.sign} disabled={this.state.loading}>{this.state.titleInformations.resetpin}{load}</button>
                        </div> : <div className="in">
                            <h1>{this.state.titleInformations.s}</h1>
                            <p>{this.state.titleInformations.u}</p>
                        </div>}
                    </div>
                </div>
            </div>
        )
    }
}

export default Pin